import { useEffect } from 'react'
import { Slider, ColorPicker, Button } from 'components'
import Flex from 'components/priority/Flex/Flex'
import Text from 'components/priority/Text/Text'
import { useRecoilValue, useRecoilState } from 'recoil'
import { selectedItemAtom, itemSelector } from 'atoms'
import { useTranslation } from 'react-i18next'

export const TextShadowDrawer = () => {
  const { t } = useTranslation()
  const selectedItem = useRecoilValue(selectedItemAtom)
  const [xOffset, setXOffset] = useRecoilState(
    itemSelector({ id: selectedItem, path: 'edits.textShadow.xOffset' }),
  )

  const [yOffset, setYOffset] = useRecoilState(
    itemSelector({ id: selectedItem, path: 'edits.textShadow.yOffset' }),
  )
  const [blur, setBlur] = useRecoilState(
    itemSelector({ id: selectedItem, path: 'edits.textShadow.blur' }),
  )

  const [opacity, setOpacity] = useRecoilState(
    itemSelector({ id: selectedItem, path: 'edits.textShadow.opacity' }),
  )
  const [color, setColor] = useRecoilState(
    itemSelector({ id: selectedItem, path: 'edits.textShadow.color' }),
  )

  useEffect(() => {
    if (!blur) setBlur(0)
    if (!xOffset) setXOffset(0)
    if (!yOffset) setYOffset(0)
    if (!color) setColor('#FFF')
    //eslint-disable-next-line
  }, [blur, xOffset, yOffset, opacity])

  const resetAll = () => {
    setBlur(0)
    setXOffset(0)
    setYOffset(0)
    setOpacity(100)
    setColor()
  }

  return (
    <Flex column padding="0 12px">
      <Text>
        {t('editor.menus.properties.elements.textShadow.offsetLRText')}
      </Text>
      <Slider
        sliderState={[xOffset, setXOffset]}
        min="-25"
        max="25"
        margin="0 0 20px"
        initialValue={0}
      />

      <Text>
        {t('editor.menus.properties.elements.textShadow.offsetTBText')}
      </Text>
      <Slider
        sliderState={[yOffset, setYOffset]}
        min="-25"
        max="25"
        margin="0 0 20px"
        initialValue={0}
      />

      <Text>
        {t('editor.menus.properties.elements.textShadow.blurSpreadText')}
      </Text>
      <Slider
        sliderState={[blur, setBlur]}
        min="0"
        max="100"
        margin="0 0 20px"
        initialValue={0}
      />

      <Text>
        {t('editor.menus.properties.elements.textShadow.opacityText')}
      </Text>
      <Slider
        sliderState={[opacity, setOpacity]}
        min="0"
        max="100"
        margin="0 0 20px"
        initialValue={100}
      />
      <ColorPicker
        color={[color, setColor]}
        label={t('editor.menus.properties.elements.textShadow.colorLabel')}
        margin="0 0 20px"
      />
      <Button margin="0 0 20px" onClick={() => resetAll()}>
        {t('editor.menus.properties.elements.textShadow.resetAllButton')}
      </Button>
    </Flex>
  )
}

export default TextShadowDrawer
